<template>
  <div class="indicator-container">
    <p class="filter-title">{{ $t('FoodOpB_2_Activity_status_hKFd' /** 活动状态 */) }}</p>
    <!-- 状态下拉框 -->
    <filter-button
      class="advertise-select"
      after
      icon="icon-outlinedpickup"
      :title="statusTitle"
      :options="advertiseItem.statusEnum"
      :filter-name="$t('FoodOpB_2_Activity_status_hKFd' /** 选择数据时间段 */)"
      @submit="submitSortStatus"
    />
    <br />
    <!-- 广告下拉框 -->
    <p class="filter-title mt24">{{ $t('Gattaran_System_wrVY_PjDQ' /** 计划名称 */) }}</p>
    <filter-button
      class="advertise-select"
      after
      icon="icon-outlinedpickup"
      :title="advertiseTitle"
      :options="advertiseItem.advertiseList"
      :filter-name="$t('Gattaran_System_wrVY_PjDQ' /** 计划名称 */)"
      @submit="submitSortAdvertise"
    />
    <rich-loading v-if="advertiseItem.loading" :size="16"></rich-loading>
    <Empty v-if="Object.keys(advertiseItem.advertiseData).length === 0"></Empty>
    <div
      v-if="!advertiseItem.loading && Object.keys(advertiseItem.advertiseData).length !== 0"
      ref="indicatorWrap"
      class="indicator-wrap"
    >
      <rich-tip
        ref="tip"
        class="customTip"
        direction="bottom"
        :style="currentStyle"
        style="max-width: 560px; border-radius: 16px"
      >
        <p>
          {{ currentValue }}
        </p>
      </rich-tip>
      <div
        v-for="(value, param, index) in advertiseItem.advertiseData"
        ref="every_advertise"
        :key="param"
        class="item"
      >
        <div class="content">
          <span class="title">{{ value.headTitle }}</span>
          <i
            v-if="param !== 'advertisePlatformPay'"
            class="crm-question"
            @click="openDesc($event, index, value.placeholder)"
          ></i>
        </div>
        <div class="money">{{ value.display }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import filterButton from '@/pages-v2/home/list/components/filter-group/filter-button.vue'
import Empty from './empty/index.vue'

export default {
  components: { filterButton, Empty },
  props: {
    advertiseItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentValue: '',
      currentStyle: {},
    }
  },
  computed: {
    statusTitle() {
      return this.advertiseItem.statusName || this.$t('FoodOpB_2_Activity_status_hKFd')
    },
    advertiseTitle() {
      return this.advertiseItem.advertiseName || this.$t('Gattaran_System_wrVY_PjDQ')
    },
  },
  created() {
    // 当状态列表为空时，重新获取
    if (this.advertiseItem.statusEnum.length === 0) {
      this.$emit('advertiseSelect', { type: 'reload' })
    }
  },

  methods: {
    openDesc(e, index, desc) {
      this.currentValue = desc
      this.$refs.tip.show()
      this.$nextTick(() => {
        // 获取气泡元素
        const tipItem = this.$refs.tip.$el
        const tipW = tipItem.offsetWidth
        // 获取外层元素最大宽度，用来和内部自适应气泡做计算
        const indicator = this.$refs.indicatorWrap
        const indicatorW = indicator.offsetWidth
        // 获取每块内容距离上方的高度
        const itemY = this.$refs.every_advertise[index].offsetTop
        const itemH = tipItem.offsetHeight
        // 获取三角指示图表
        const sanjiao = document.querySelector('.rich-tip-angle')
        if (tipW !== indicatorW && (index === 1 || index === 3 || index === 5)) {
          sanjiao.style.left = e.target.offsetLeft - (indicatorW - tipW) + 6 + 'px'
        } else {
          sanjiao.style.left = e.target.offsetLeft + 6 + 'px'
        }
        // 计算距离顶部的距离
        // 默认左侧计算
        // 区分右侧设置right(使用下标区分)
        this.currentStyle = {
          right: index === 1 || index === 3 || index === 5 ? '0' : '',
          top: itemY - itemH + 'px',
        }
      })
    },
    submitSortStatus(data) {
      this.$emit('advertiseSelect', { type: 'status', data })
    },
    submitSortAdvertise(data) {
      this.$emit('advertiseSelect', { type: 'advertise', data })
    },
  },
}
</script>
<style lang="scss" scoped>
.advertise-select {
  background: #f2f2f5;
  width: 100%;
  max-width: calc(100% - 32px);
  margin-right: 0;
  padding-right: 0;
}
.filter-title {
  font-family: DiDi Sans Pro;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  margin-bottom: 12px;
}
.mt24 {
  margin-top: 24px;
}
.indicator-wrap {
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #f2f2f5;
  margin: 32px -24px -24px;
  padding-top: 32px;
  .item {
    width: calc((100% - 16px) / 2);
    border-radius: 24px;
    background: #fff;
    margin-bottom: 16px;
    padding: 24px 0;
    .content {
      display: flex;
      justify-content: space-between;
      font-family: DiDi Sans Pro;
      padding: 0 24px 16px;
      .title {
        font-size: 28px;
        line-height: 36px;
        color: #595c66;
        margin-right: 8px;
      }
      i {
        font-size: 24px;
      }
    }
    .money {
      font-size: 36px;
      line-height: 44px;
      padding-left: 24px;
      margin-top: 16px;
      color: #282b33;
      font-weight: bold;
    }
  }
  .item:nth-child(2n) {
    margin-right: 16px;
  }
}
::v-deep .indicator-wrap .rich-tip .rich-tip-close {
  font-size: 32px;
  display: flex;
  align-items: center;
  height: 100%;
  top: 0;
}
</style>
